import t, { forwardRef as P } from "react";
import { modal as m } from "@huspy/styled-system/recipes";
import { splitCssProps as x } from "@huspy/styled-system/jsx";
import { cx as E, css as v } from "@huspy/styled-system/css";
import { X as C } from "lucide-react";
import { token as g } from "@huspy/styled-system/tokens";
import "@ark-ui/react";
import { Flex as u } from "../../components/box/index.mjs";
import "../../components/button/button.mjs";
import "../../components/checkbox/checkbox.mjs";
import { IconButton as b } from "../../components/icon-button/icon-button.mjs";
import "../../components/input/input.mjs";
import "../../components/input/input-group.mjs";
import "../../components/phone-input/phone-input.mjs";
import "../../components/pin-input/pin-input.mjs";
import "../../components/popover/popover.mjs";
import "../../components/chip/chip.mjs";
import "../../components/property-tag/property-tag.mjs";
import "../../components/slider/slider.mjs";
import "../../components/alert/alert.mjs";
import { Text as h } from "../../components/typography/text.mjs";
import "../../components/typography/title.mjs";
import "../../components/menu/menu.mjs";
import "../../components/progress/progress.mjs";
import "../../components/date-picker/date-picker.mjs";
import "../../components/tabs/tabs.mjs";
import "../../components/collapsible/collapsible.mjs";
import "../../components/dialog/dialog.mjs";
import "../../components/radio/radio.mjs";
import "../../components/radio-button/radio-button.mjs";
import "../../components/file-upload/file-upload.mjs";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "../../components/table/table.mjs";
import "../../components/pagination/pagination.mjs";
import "../../components/combobox/combobox.mjs";
import "../../components/select/select.mjs";
import "../../components/badge/badge.mjs";
import "../../components/property-chip/property-chip.mjs";
import "../../components/number-input/number-input.mjs";
import "../../components/switch/switch.mjs";
import "../../components/toast/base.mjs";
import "../../components/spinner/spinner.mjs";
import "../../components/property-badge/property-badge.mjs";
import "../../components/drawer/drawer.mjs";
import "../../components/skeleton/skeleton.mjs";
import { Slot as y } from "../../utils/Slot.mjs";
const B = ({ title: r, description: o, ...i }) => /* @__PURE__ */ t.createElement(
  u,
  {
    flexDir: "column",
    gap: "1",
    paddingX: "6",
    paddingTop: "4",
    paddingBottom: "3",
    borderBottom: "1px solid",
    borderColor: "fg-senary",
    ...i
  },
  /* @__PURE__ */ t.createElement(h, { size: "2xl", fontWeight: "medium" }, r),
  o ? /* @__PURE__ */ t.createElement(h, { size: "lg", fontWeight: "regular", color: "text-tertiary" }, o) : null
), M = P(({ asChild: r, ...o }, i) => {
  const p = r ? y : u, [e, s] = m.splitVariantProps(o), [a, n] = x(s), { children: l, className: c, ...d } = n, f = m(e);
  return /* @__PURE__ */ t.createElement(p, { ref: i, className: E(f.main, v(a), c), ...d }, l);
}), N = P(({ asChild: r, ...o }, i) => {
  const p = r ? y : u, [e, s] = m.splitVariantProps(o), [a, n] = x(s), { children: l, className: c, ...d } = n, f = m(e);
  return /* @__PURE__ */ t.createElement(p, { ref: i, className: E(f.footer, v(a), c), ...d }, l);
}), z = P((r, o) => /* @__PURE__ */ t.createElement(
  b,
  {
    ref: o,
    "aria-label": "Close Dialog",
    variant: "tertiary",
    size: "sm",
    ...r,
    minWidth: "unset"
  },
  /* @__PURE__ */ t.createElement(
    C,
    {
      width: g.var("spacing.4"),
      height: g.var("spacing.4"),
      color: g.var("colors.fg-primary")
    }
  )
)), Co = {
  Header: B,
  Main: M,
  Footer: N,
  CloseButton: z
};
export {
  Co as Modal
};
